import { createContext, useContext, useState, ReactNode } from 'react';

interface StickyCartContextType {
  isStickyCartVisible: boolean;
  setIsStickyCartVisible: (visible: boolean) => void;
  isCartSidebarOpen: boolean;
  setIsCartSidebarOpen: (open: boolean) => void;
}

const StickyCartContext = createContext<StickyCartContextType | undefined>(undefined);

export const StickyCartProvider = ({ children }: { children: ReactNode }) => {
  const [isStickyCartVisible, setIsStickyCartVisible] = useState(false);
  const [isCartSidebarOpen, setIsCartSidebarOpen] = useState(false);

  return (
    <StickyCartContext.Provider value={{ 
      isStickyCartVisible, 
      setIsStickyCartVisible,
      isCartSidebarOpen,
      setIsCartSidebarOpen
    }}>
      {children}
    </StickyCartContext.Provider>
  );
};

export const useStickyCart = () => {
  const context = useContext(StickyCartContext);
  if (context === undefined) {
    throw new Error('useStickyCart must be used within a StickyCartProvider');
  }
  return context;
};
